import { createFileRoute, getRouteApi } from '@tanstack/react-router';

import { resolveIdentity } from '../modules/auth/domain/resolve-identity';
import { useAuthState } from '../modules/auth/ui/auth-state-context';
import { PendingItemsPage } from '../modules/offline/ui/pages/PendingItemsPage';

export const Route = createFileRoute('/_authenticated/pending')({
  component: PendingItemsPageWrapper,
});

// pwa-offline-first Slice 6 (coordinator finding #4) — same identity
// resolution as `_authenticated.checkin.tsx`; see resolve-identity.ts's own
// doc comment.
const authenticatedRouteApi = getRouteApi('/_authenticated');

function PendingItemsPageWrapper() {
  const { session } = useAuthState();
  const { offlineProfile } = authenticatedRouteApi.useRouteContext();
  const identity = resolveIdentity(session, offlineProfile);

  return <PendingItemsPage identity={identity} />;
}
